/*
List of references to the tile sheet

Written with help from Ciabatta's revenge Tutorial by Drew Conley

Jackson Wiebe 
3519635
09/10/2023
*/

export const TILES = {
  // Basics
  BLANK: "0x0",
  SHADOW: "1x3",

  // Icons
  CONTINUE_BUTTON: "7x3",
  EDIT_BUTTON: "8x3",
  RESUME_BUTTON: "9x3",
  RESTART_BUTTON: "10x3",
  MAP_BUTTON: "11x3",
  CLOCK: "12x3",
  SETTINGS: "13x3",
  QUESTION: "0x3",

  //Minerals
  MINERAL_DIRT: "0x9",
  MINERAL_COPPER: "1x9",
  MINERAL_ZINC: "2x9",
  MINERAL_GOLD: "3x9",
  MINERAL_LITHIUM: "4x9",
  MINERAL_NEODYMIUM: "5x9",
  MINERAL_YTTRIUM: "6x9",

  // Locks and Keys
  BLUE_LOCK: "0x4",
  BLUE_KEY: "1x4",
  GREEN_LOCK: "2x4",
  GREEN_KEY: "3x4",
  UNLOCKED_LOCK: "4x4",

  // Water
  WATER1: "0x5",
  WATER2: "1x5",

  // Ice
  ICE: "0x6",
  ICE_TOP_LEFT: "1x6",
  ICE_TOP_RIGHT: "2x6",
  ICE_BOTTOM_LEFT: "3x6",
  ICE_BOTTOM_RIGHT: "4x6",

  // Fire
  FIRE1: "0x7",
  FIRE2: "1x7",
  FIRE3: "2x7",

  // Conveyors
  CONVEYOR_DOWN: "0x8",
  CONVEYOR_UP: "1x8",
  CONVEYOR_RIGHT: "2x8",
  CONVEYOR_LEFT: "3x8",

  // Spawns
  ENEMY_LEFT_SPAWN: "4x8",
  ENEMY_RIGHT_SPAWN: "5x8",
  ENEMY_UP_SPAWN: "6x8",
  ENEMY_DOWN_SPAWN: "7x8",
  ENEMY_FLYING_LEFT_SPAWN: "8x8",
  ENEMY_FLYING_RIGHT_SPAWN: "9x8",
  ENEMY_FLYING_UP_SPAWN: "10x8",
  ENEMY_FLYING_DOWN_SPAWN: "11x8",
  ENEMY_ROAMING_SPAWN: "12x8",
  HERO_SPAWN: "13x8",
  CIABATTA_SPAWN: "14x8",

  //Goal
  GOAL_DISABLED: "2x5",
  GOAL_ENABLED: "3x5",

  //Particle Dusty explosion
  PARTICLE_1: "0x10",
  PARTICLE_2: "1x10",
  PARTICLE_3: "2x10",
  PARTICLE_4: "3x10",
  PARTICLE_5: "4x10",

  //Engine Smoke
  SMOKE_PARTICLE_1: "5x10",
  SMOKE_PARTICLE_2: "6x10",
  SMOKE_PARTICLE_3: "7x10",
  SMOKE_PARTICLE_4: "8x10",
  SMOKE_PARTICLE_5: "9x10",

  //Characters
  HERO_RIGHT: "0x11",
  HERO_RUN_1_RIGHT: "2x11",
  HERO_RUN_2_RIGHT: "4x11",

  //Character Options
  DRILL_1_RIGHT: "0x13",
  DRILL_1_DOWN: "2x13"
};